export default defineAppConfig({
  nuxtIcon: {},
  nui: {
    defaultShapes: {},
    BaseThemeToggle: {
      disableTransitions: "false",
    },
  },
  tairo: {
    title: "",
    sidebar: {
      toolbar: {
        showNavBurger: true,
        tools: [
          {
            component: "CoreThemeToggle",
            props: {
              disableTransitions: true,
            },
          },
          {
            component: "CoreToolbarNotifications",
          },
          {
            component: "CoreToolbarActivity",
          },
          {
            component: "CoreToolbarAccountMenu",
          },
        ],
      },
      circularMenu: {
        enabled: false,
        tools: [
          {
            component: "CoreThemeToggle",
            props: {
              class: "ms-auto",
              disableTransitions: true,
              inverted: true,
            },
          },
          {
            component: "CoreCircularMenuNotifications",
          },
          {
            component: "CoreCircularMenuActivity",
          },
        ],
      },
      navigation: {
        logo: {
          component: "TairoLogo",
          props: { class: "text-primary-600 h-10" },
        },
        items: [
          {
            title: "Dashboards",
            icon: { name: "ph:sidebar-duotone", class: "w-5 h-5" },
            subsidebar: { component: "DemoSubsidebarDashboards" },
            activePath: "/dashboards",
          },
          {
            title: "Layouts",
            icon: { name: "ph:app-window-duotone", class: "w-5 h-5" },
            subsidebar: { component: "DemoSubsidebarLayouts" },
            activePath: "/layouts",
          },
          {
            title: "Settings",
            icon: { name: "ph:gear-six-duotone", class: "w-5 h-5" },
            to: "/admin/settings",
            position: "end",
          },
          {
            title: "My Account",
            component: "CoreAccountMenu",
            position: "end",
          },
        ],
      },
    },
    collapse: {
      toolbar: {
        enabled: true,
        showTitle: true,
        showNavBurger: true,
        tools: [
          {
            component: "CoreToolbarMoney",
          },
          {
            component: "CoreToolbarCoin",
          },
          // {
          //   component: 'CoreThemeToggle',
          //   props: {
          //     disableTransitions: true,
          //   },
          // },
          {
            component: "CoreToolbarAccountMenu",
          },
        ],
      },
      circularMenu: {
        enabled: false,
        tools: [],
      },
      navigation: {
        enabled: true,
        header: {},
        footer: {},
        items: [
          {
            name: "menu_home",
            icon: {
              name: "ic:baseline-home",
              class: "w-5 h-5",
            },
            activePath: "/home",
            to: "/home",
            meta: {},
          },
          {
            icon: {
              name: "material-symbols:other-admission-outline-sharp",
              class: "w-5 h-5",
            },
            name: "menu_gig_management",
            activeRoutes: [
              "/missions/pending-approval",
              "/missions",
              "/missions/proof-decline-request",
              "/store/orders",
            ],
            meta: {
              permission: "menu_main_gig",
            },
            children: [
              {
                name: "menu_pending_approval",
                icon: {
                  name: "material-symbols:pending-actions-rounded",
                  class: "w-5 h-5",
                },
                to: "/missions/pending-approval",
                meta: {
                  permission: "menu_missions_pending_approval",
                },
              },
              {
                name: "menu_gig_edit",
                icon: {
                  name: "mdi:text-box-edit-outline",
                  class: "w-5 h-5",
                },
                to: "/missions",
                meta: {
                  permission: "menu_missions",
                },
              },
              {
                name: "menu_decline_request",
                icon: {
                  name: "fluent-mdl2:entry-decline",
                  class: "w-5 h-5",
                },
                to: "/missions/proof-decline-request",
                meta: {
                  permission: "menu_missions_proof_decline_request",
                },
              },
              {
                name: "menu_store_orders",
                icon: {
                  name: "mdi:store-clock-outline",
                  class: "w-5 h-5",
                },
                to: "/store/orders",
                meta: {
                  permission: "menu_store_orders",
                },
              },
            ],
          },
          {
            icon: {
              name: "oui:app-index-management",
              class: "w-5 h-5",
            },
            activePath: "/subscriptions",
            name: "menu_subscription_management",
            meta: {
              permission: "menu_main_subscriptions",
            },
            children: [
              {
                name: "menu_subscription_approve",
                icon: {
                  name: "material-symbols:pending-actions-rounded",
                  class: "w-5 h-5",
                },
                to: "/subscriptions/pending-approval",
                meta: {
                  permission: "menu_subscription_waiting_approve_list",
                },
              },
              {
                name: "menu_subscription_edit",
                icon: {
                  name: "material-symbols-light:box-edit-outline-sharp",
                  class: "w-5 h-5",
                },
                to: "/subscriptions",
                meta: {
                  permission: "menu_subscriptions",
                },
              },
            ],
          },
          {
            icon: {
              name: "solar:file-outline",
              class: "w-5 h-5",
            },
            name: "menu_proof_inspect",
            activeRoutes: [
              "/missions/proof-pending-users",
              "/missions/proof-pending-approval",
              "/missions/user-with-proofs",
            ],
            meta: {
              permission: "menu_main_proofs",
            },
            children: [
              {
                name: "menu_user_in_proofs",
                icon: {
                  name: "basil:file-user-outline",
                  class: "w-5 h-5",
                },
                to: "/missions/proof-pending-users",
                meta: {
                  permission: "menu_missions_proof_pending_users",
                },
              },
              {
                name: "menu_mission_in_proofs",
                icon: {
                  name: "tdesign:file-1",
                  class: "w-5 h-5",
                },
                to: "/missions/proof-pending-approval",
                meta: {
                  permission: "menu_missions_proof_pending_approval",
                },
              },
              {
                name: "menu_mission_user_proofs",
                icon: {
                  name: "material-symbols:select-all-sharp",
                  class: "w-5 h-5",
                },
                to: "/missions/user-with-proofs",
                meta: {
                  permission: "menu_missions_user_proofs",
                },
              },
            ],
          },
          {
            icon: {
              name: "ion:social-dribbble-outline",
              class: "w-5 h-5",
            },
            name: "menu_social_media_accounts",
            activeRoutes: [
              "/social/accounts/proof",
              "/social/accounts/banned",
              "/social/accounts",
            ],
            meta: {
              permission: "menu_main_social_accounts",
            },
            children: [
              {
                name: "menu_social_pending_approval",
                icon: {
                  name: "mdi:account-pending-outline",
                  class: "w-5 h-5",
                },
                to: "/social/accounts/proof",
                meta: {
                  permission: "menu_social_accounts_proof",
                },
              },
              {
                name: "menu_social_banneds",
                icon: {
                  name: "lineicons:ban-2",
                  class: "w-5 h-5",
                },
                to: "/social/accounts/banned",
                meta: {
                  permission: "menu_social_accounts_banned",
                },
              },
              {
                name: "menu_social_all_accounts",
                icon: {
                  name: "mdi:accounts-group-outline",
                  class: "w-5 h-5",
                },
                to: "/social/accounts",
                meta: {
                  permission: "menu_social_accounts",
                },
              },
            ],
          },
          {
            icon: {
              name: "mynaui:users-solid",
              class: "w-5 h-5",
            },
            name: "menu_users",
            activeRoutes: ["/users", "/users/banned"],
            meta: {
              permission: "menu_main_users",
            },
            children: [
              {
                name: "menu_all_user",
                icon: {
                  name: "fa-solid:users",
                  class: "w-5 h-5",
                },
                to: "/users",
                meta: {
                  permission: "menu_users",
                },
              },
              {
                name: "menu_users_banned",
                icon: {
                  name: "fa6-solid:users-slash",
                  class: "w-5 h-5",
                },
                to: "/users/banned",
                meta: {
                  permission: "menu_users_banned",
                },
              },
            ],
          },
          {
            name: "menu_references",
            icon: { name: "solar:user-hand-up-linear", class: "w-5 h-5" },
            to: "/references",
            meta: {
              permission: "menu_references",
            },
          },
          {
            icon: {
              name: "ic:sharp-design-services",
              class: "w-5 h-5",
            },
            name: "menu_service_settings",
            activeRoutes: ["/services", "/service-packages"],
            meta: {
              permission: "menu_main_service_settings",
            },
            children: [
              {
                name: "menu_services",
                icon: {
                  name: "icons8:services",
                  class: "w-5 h-5",
                },
                to: "/services",
                meta: {
                  permission: "menu_services",
                },
              },
              {
                name: "menu_panel_packages",
                icon: {
                  name: "fluent-emoji-high-contrast:package",
                  class: "w-5 h-5",
                },
                to: "/service-packages",
                meta: {
                  permission: "menu_service_packages",
                },
              },
              {
                name: "menu_subscription_packages",
                icon: {
                  name: "material-symbols:subscriptions-outline-rounded",
                  class: "w-5 h-5",
                },
                to: "/subscription-packages",
                meta: {
                  permission: "menu_service_packages",
                },
              },
            ],
          },
          {
            icon: {
              name: "mdi:store-settings-outline",
              class: "w-5 h-5",
            },
            name: "menu_store_settings",
            activeRoutes: [
              "/store/settings/packages",
              "/store/settings/groups",
              "/store/settings/services",
              "/perfect-service",
            ],
            meta: {
              permission: "menu_main_store_settings",
            },
            children: [
              {
                name: "menu_packages",
                icon: {
                  name: "pajamas:package",
                  class: "w-5 h-5",
                },
                to: "/store/settings/packages",
                meta: {
                  permission: "menu_store_settings_packages",
                },
              },
              {
                name: "menu_groups",
                icon: {
                  name: "ant-design:group-outlined",
                  class: "w-5 h-5",
                },
                to: "/store/settings/groups",
                meta: {
                  permission: "menu_store_settings_groups",
                },
              },
              {
                name: "menu_integrated_services",
                icon: {
                  name: "mdi:package-variant-closed-plus",
                  class: "w-5 h-5",
                },
                to: "/store/settings/services",
                meta: {
                  permission: "menu_store_settings_services",
                },
              },
              {
                name: "menu_perfect_service_list",
                icon: {
                  name: "hugeicons:package-open",
                  class: "w-5 h-5",
                },
                to: "/perfect-service",
                meta: {
                  permission: "menu_perfect_service",
                },
              },
            ],
          },
          {
            icon: {
              name: "majesticons:award-line",
              class: "w-5 h-5",
            },
            name: "menu_reward_settings",
            activeRoutes: [
              "/reward-settings/categories",
              "/reward-settings/items",
            ],
            meta: {
              permission: "menu_main_reward_settings",
            },
            children: [
              {
                name: "menu_reward_categories",
                icon: {
                  name: "material-symbols-light:award-star-outline",
                  class: "w-5 h-5",
                },
                to: "/reward-settings/categories",
                meta: {
                  permission: "menu_reward_settings_categories",
                },
              },
              {
                name: "menu_reward_services",
                icon: {
                  name: "carbon:web-services-container",
                  class: "w-5 h-5",
                },
                to: "/reward-settings/items",
                meta: {
                  permission: "menu_reward_settings_items",
                },
              },
            ],
          },
          {
            name: "menu_reward_request",
            icon: {
              name: "basil:award-outline",
              class: "w-5 h-5",
            },
            to: "/reward/requests",
            meta: {
              permission: "menu_reward_requests",
            },
          },
          {
            name: "menu_reward_request_me",
            icon: {
              name: "basil:award-outline",
              class: "w-5 h-5",
            },
            to: "/reward/requests/me",
            meta: {
              permission: "menu_reward_requests_me",
            },
          },
          {
            name: "menu_ticket_management",
            icon: { name: "icon-park-outline:ticket", class: "w-5 h-5" },
            to: "/tickets",
            meta: {
              permission: "menu_tickets",
            },
          },
          {
            name: "menu_payment_management",
            icon: { name: "ic:outline-payments", class: "w-5 h-5" },
            to: "/payment/plans",
            meta: {
              permission: "menu_payment_plans",
            },
          },
          {
            name: "menu_reward_accounts",
            icon: {
              name: "fluent:person-accounts-20-filled",
              class: "w-5 h-5",
            },
            to: "/payment/accounts/me",
            meta: {
              permission: "menu_payment_accounts_me",
            },
          },
          {
            name: "menu_order_tracking",
            icon: {
              name: "lsicon:place-order-filled",
              class: "w-5 h-5",
            },
            activePath: "/order-tracking",
            to: "/order-tracking",
            meta: {
              permission: "menu_order_tracking",
            },
          },
          {
            name: "menu_store_order_create",
            icon: {
              name: "material-symbols:create-new-folder",
              class: "w-5 h-5",
            },
            to: "/store/orders/me/create",
            meta: {
              permission: "menu_store_orders_me_create",
            },
          },
          {
            name: "menu_balance_package",
            icon: {
              name: "octicon:package-dependencies-16",
              class: "w-5 h-5",
            },
            to: "/balance/packages",
            meta: {
              permission: "menu_balance_packages",
            },
          },
          {
            name: "menu_payment_action_me",
            icon: {
              name: "lucide:package-check",
              class: "w-5 h-5",
            },
            to: "/payment/plans/me",
            meta: {
              permission: "menu_payment_plans_me",
            },
          },
          {
            name: "menu_price_list",
            icon: {
              name: "fa:try",
              class: "w-5 h-5",
            },
            to: "/price/list",
            meta: {
              permission: "menu_price_list",
            },
          },
          {
            name: "menu_ticket_requests_me",
            icon: { name: "mdi:ticket-account", class: "w-5 h-5" },
            to: "/tickets/me",
            meta: {
              permission: "menu_tickets_me",
            },
          },
          {
            name: "menu_proofs",
            icon: {
              name: "fluent:clipboard-task-list-ltr-24-regular",
              class: "w-5 h-5",
            },
            to: "/me/missions/proofs",
            meta: {
              permission: "menu_proofs",
            },
          },
          {
            name: "menu_payment_accounts",
            icon: { name: "mdi:account-payment-outline", class: "w-5 h-5" },
            to: "/payment/accounts",
            meta: {
              permission: "menu_payment_accounts",
            },
          },
          {
            name: "menu_reference_system",
            icon: {
              name: "solar:hand-money-linear",
              class: "w-5 h-5",
            },
            to: "/reference-system",
            meta: {
              permission: "menu_my_references",
            },
          },
          {
            name: "menu_sss",
            icon: { name: "mdi:faq", class: "w-5 h-5" },
            to: "/faq",
            meta: {
              permission: "menu_faq",
            },
          },
          {
            icon: {
              name: "ix:log",
              class: "w-5 h-5",
            },
            name: "menu_information_logs",
            activeRoutes: ["/information/categories"],
            meta: {
              permission: "menu_main_information_logs",
            },
            children: [
              {
                name: "menu_perfect_service_price_logs",
                icon: {
                  name: "material-symbols:price-change-outline-rounded",
                  class: "w-5 h-5",
                },
                to: "/information/perfect-price-logs",
                meta: {
                  permission: "menu_perfect_service_price_logs",
                },
              },
            ],
          },
          {
            name: "menu_settings",
            icon: { name: "hugeicons:settings-04", class: "w-5 h-5" },
            to: "/admin/settings",
            meta: {
              permission: "menu_admin_settings",
            },
          },
          {
            name: "my_account",
            icon: { name: "ph:drop-half-bottom-duotone", class: "w-5 h-5" },
            click: () => {
              const isSwitcherOpen = useState("switcher-open", () => false)
              isSwitcherOpen.value = true
            },
            position: "end",
            component: {
              name: "CoreAccountMenu",
            },
          },
        ],
      },
    },
    topnav: {
      navigation: {
        enabled: true,
        logo: {
          component: "TairoLogo",
          props: { class: "text-primary-600 h-10 w-10" },
        },
        header: {},
        items: [
          {
            name: "Dashboard",
            icon: { name: "ph:gauge-duotone", class: "w-6 h-6" },
            activePath: "/dashboards/sales",
            to: "/dashboards/sales",
          },
        ],
      },
      circularMenu: {
        enabled: true,
        tools: [],
      },
      toolbar: {
        enabled: true,
        showTitle: false,
        tools: [],
      },
    },

    error: {
      logo: {
        component: "img",
        props: {
          src: "/img/illustrations/system/404-1.svg",
          class: "relative z-20 w-full max-w-lg mx-auto",
        },
      },
    },
  },
})
